/* Jquery match height */
$(document).ready(function(){
  $('.footer-list').matchHeight();
  $('.toepassing-blok .toepassing-content').matchHeight();
  $('.producten-list .card-body').matchHeight();
});
